import { logger } from 'modules/app/utils/logger';
import { GaiaApolloClient } from '@rosetta/gaia-data';
import { CacheMutation } from './apollo/cache-graphql';

export async function flushCache(id) {
  logger.debug('Flushing cache: ' + id);
  await GaiaApolloClient.mutate({ mutation: CacheMutation, variables: { id } });
}
